import { render, staticRenderFns } from "./PageMobilePayment.vue?vue&type=template&id=3c7063c6"
import script from "./PageMobilePayment.vue?vue&type=script&lang=js"
export * from "./PageMobilePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports